import { Component, HostListener, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-header-new-deal",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  @Input() lang: string;
  public isLangListVisible: boolean = false;

  public currentLang: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {}

  toggleLangList() {
    this.isLangListVisible = !this.isLangListVisible;
  }

  changeLang(lang: string) {
    if (lang == "en") this.currentLang = "ENG";
    else if (lang == "ru") this.currentLang = "РУС";
    else this.currentLang = "ՀԱՅ";
    localStorage.setItem("lang", lang);
    this.translateService.use(lang);
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: Event): void {
    const targetElement = event.target as HTMLElement;

    // Check if the click is outside the .lang element
    if (!targetElement.closest(".lang")) {
      this.isLangListVisible = false;
    }
  }
}
